import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { JsonQueryTerm, JsonQueryTerms } from 'shared/models/JsonQueryElement';
import { IGetJsonQueryResponse } from 'shared/repositories/commercial-filters-frontend/v1/get-json-query';
import { JsonQueryFilters } from 'shared/types/JsonQuery';
import { ListingSortType } from 'shared/types/ListingSortType';

import { ESliceKeys } from '../../internal/ESliceKeys';

export type JsonQueryInitialState = {
  filters: JsonQueryFilters;
  page: number;
  sort: ListingSortType;
};

const jsonQueryInitialState: JsonQueryInitialState = {
  filters: { _type: 'commercialsale', engine_version: new JsonQueryTerm(1), region: new JsonQueryTerms([1]) },
  page: 1,
  sort: 'default',
};

export const { reducer: jsonQueryReducer, actions: jsonQueryActions } = createSlice({
  initialState: { ...jsonQueryInitialState },
  name: ESliceKeys.JsonQuery,
  reducers: {
    setFilters(state, action: PayloadAction<IGetJsonQueryResponse>) {
      state.filters = action.payload;
    },
    setPage(state, action: PayloadAction<number>) {
      state.page = action.payload;
    },
    setSort(state, action: PayloadAction<ListingSortType>) {
      state.sort = action.payload;
    },
    setSortWithPageReset(state, action: PayloadAction<ListingSortType>) {
      state.sort = action.payload;
      state.page = jsonQueryInitialState.page;
    },
  },
});
